import React, { memo } from 'react'
import Button from '../button/Button'
import { BUTTON_STYLE_DEFAULT_PRIMARY } from '../../libraries/ButtonTheme'
import { ArrowRightIcon } from '../../assets/icons/ArrowRightIcon'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './InformativoAssembleiasComImagem.scss'
const rootClassName = 'informativo-assembleias-com-imagem'

interface InformativoAssembleiasComImagemProps {
  urlImg?: string
  title?: string
  subtitle?: string
  buttonLabel?: string
  onButtonClick?: (evt?: any) => void
  reverse?: boolean
}

function InformativoAssembleiasComImagem(
  props: InformativoAssembleiasComImagemProps
) {
  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        props.reverse ? 'reverse' : ''
      ])}
    >
      <div className={`${rootClassName}-text`}>
        <div className={`${rootClassName}-title`}>{props.title}</div>
        <p className={`${rootClassName}-sub-title nunito`}>{props.subtitle}</p>
        <div className={`${rootClassName}-button`}>
          <Button
            theme={BUTTON_STYLE_DEFAULT_PRIMARY}
            onClick={props.onButtonClick}
            rightIcon={<ArrowRightIcon />}
          >
            {props.buttonLabel}
          </Button>
        </div>
      </div>
      <div
        className={`${rootClassName}-photo`}
        style={{ backgroundImage: `url(${props.urlImg})` }}
      >
        <img alt='img' src={props.urlImg} />
      </div>
    </div>
  )
}

export default memo(InformativoAssembleiasComImagem)
